export const getStoredKey = () => localStorage.getItem('key')